// extracted by mini-css-extract-plugin
export default {"amount":"AmountComponent_amount__mazEt","green":"AmountComponent_green__yM93+","red":"AmountComponent_red__BwLlH"};